var map = {
	"./amex.png": 1032,
	"./diners.png": 1033,
	"./discover.png": 1034,
	"./jcb.png": 1035,
	"./maestro.png": 1264,
	"./mastercard.png": 1036,
	"./stripe.png": 1037,
	"./union.png": 1038,
	"./unknown.png": 713,
	"./visa.png": 1039
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1263;